import PullToRefresh from "react-simple-pull-to-refresh"

import { LoadingSpinner } from "@/components/shared"
import { GoBack } from "@/components/shared/layout"
import { AffiliateProductDetails } from "@/features/jobs/affiliates/components/affiliate-product"
import {
  AffiliateCampaignDetail,
  ApplyCampaignForm
} from "@/features/jobs/explore/components/campaign"
import { useQueryCampaignById } from "@/modules/helpers/hooks"
import { cn } from "@/modules/helpers/hooks/shared/utils"

interface CampaignDetailsProps {
  id: string
}

const CampaignDetails = ({ id }: CampaignDetailsProps) => {
  const { data, refetch, isLoading } = useQueryCampaignById(id)

  const handleRefresh = async () => {
    await refetch()
  }

  return (
    <>
      <div
        className={cn(
          "flex flex-col h-screen absolute top-0 z-50 w-full max-h-[100dvh] items-center justify-center bg-white text-black transition-all duration-300",
          {
            "opacity-0 z-0 ": !isLoading
          }
        )}
      >
        <LoadingSpinner className="w-32 h-32" />
      </div>
      <div className="bg-white sticky top-0 z-20">
        <GoBack />
      </div>
      <div
        className={cn("flex flex-col", {
          "opacity-0": isLoading || !data?.id
        })}
      >
        {/* Content */}
        <PullToRefresh
          onRefresh={handleRefresh}
          pullingContent=""
          refreshingContent={<LoadingSpinner className="w-20 h-20" />}
          maxPullDownDistance={80}
        >
          <div className="flex-1 flex flex-col">
            <AffiliateCampaignDetail data={data} layoutBanner="upper" />
            <div className="px-4 pb-8 bg-background pt-4 rounded-t-3xl">
              <AffiliateProductDetails
                id={data?.products?.id}
                layoutBanner="upper"
                isShowAction={false}
                data={data?.products}
                preload={true}
              />
            </div>
          </div>
        </PullToRefresh>
      </div>
      <div className="sticky bottom-0 z-20 bg-white">
        <ApplyCampaignForm data={data} refetch={refetch} />
      </div>
    </>
  )
}

export default CampaignDetails
